import { useI18n } from "./i18n";
import { CHANNELS, type Channel } from "./vend";

/** The payment methods as a radio group (Aqua's rows, radio dot first). */
export function ChannelPicker({
  value,
  onChange,
  disabled,
}: {
  value: Channel;
  onChange: (c: Channel) => void;
  disabled?: boolean;
}) {
  const { t } = useI18n();
  return (
    <div className="v-channels" role="radiogroup" aria-label={t("vend.method")}>
      {CHANNELS.map((c) => (
        <button
          key={c}
          type="button"
          role="radio"
          aria-checked={value === c}
          className="aseed-payment-row v-channel"
          disabled={disabled}
          onClick={() => onChange(c)}
        >
          <span className="v-channel__dot" aria-hidden="true" />
          <span className={`v-channel__badge v-channel__badge--${c}`} aria-hidden="true">
            {BADGE[c]}
          </span>
          <span className="v-channel__label">{t(`payment.channel.${c}`)}</span>
        </button>
      ))}
    </div>
  );
}

/** Neutral short marks, not the brands' logos. */
const BADGE: Record<Channel, string> = {
  paypay: "P",
  rakuten: "R",
  aupay: "au",
  docomopay: "d",
  wechat: "W",
  alipay: "A",
  aeonpay: "Æ",
};
